import { FormControl, FormGroupDirective, FormsModule, NgForm, ReactiveFormsModule, ValidatorFn } from "@angular/forms";
import { CommonModule, formatDate } from '@angular/common';
import { Component, inject, OnInit, TemplateRef,Renderer2 } from '@angular/core';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import {  ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { DynamictableComponent } from 'src/app/shared/dynamictable/dynamictable.component';
import { BatRequestService } from "src/app/services/bat-request/bat-request.service";
import {MsalService } from '@azure/msal-angular';
import { MatIconModule } from '@angular/material/icon';
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { MatDialog } from '@angular/material/dialog';
import { MatExpansionModule } from "@angular/material/expansion";
import { MatAccordion } from "@angular/material/expansion";
import { ToastrService } from "ngx-toastr";
import { saveAs } from "file-saver";
import { ChangeDetectorRef } from '@angular/core';
import { NgxSpinnerModule } from "ngx-spinner";
import { SpinnerService } from 'src/app/services/spinner/spinner.service';
import { MatInputModule } from "@angular/material/input";
import { MatButtonModule } from "@angular/material/button";
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { RequestStatusService } from "src/app/services/reports/request-status.service";
import * as XLSX from 'xlsx';
import { DateTime } from 'luxon';
import { BillingAdjustmentStatusEnum, FilterDto, formatDateRange } from "src/utilities";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatCardModule } from '@angular/material/card';
import { LegendComponent } from 'src/app/shared/legend/legend.component';
import { Router } from "@angular/router";
@Component({
    selector: 'app-request-status',
    imports: [
        FormsModule,
        ReactiveFormsModule, CommonModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        DynamictableComponent,
        MatIconModule,
        MatAccordion,
        MatExpansionModule,
        NgxSpinnerModule,
        MatInputModule,
        MatButtonModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatSelectModule,
        SharedModule,
        MatCardModule,
        LegendComponent
    ],
    templateUrl: './request-status.component.html',
    styleUrl: './request-status.component.scss'
})
export class RequestStatusComponent {
  private blobUrl: string | null = null;
  adminModalRef: BsModalRef;
  isLoading: boolean = true;
  dataSource = new MatTableDataSource<any>([]);
  panels: any[] = [];
  reportTypeFlag: string = 'BAT';
  //miApprovalLegend: string = 'MI Approver- Requests marked with this note are pending approval beyond the standard timeframe';
  miApprovalLegend: string ='MI Approval - Indicates requests that have been awaiting approval for more than 3 days.'
  gbsApprovalLegend: string = 'GBS Approval - Indicates requests that have been awaiting approval for more than 5 days for goodwill requests and 14 days for others.';
  isGoodWillRequest: boolean = false;
  requestReportSearch:any ={
    startDate:new Date(),
    endDate:new Date(),
    reportType: 1,
    statusType:0
  }
  pageSize: number=0;
  totalCount: number=0;
  formValue:any
  pdfSrc: SafeResourceUrl | null = null;
  adjReqIdError: boolean = false;
  adjReqIdErrorMessage: string = ''; // Error message for AdjReqId validation
  statusFilter: string = '';
  isDetailedReports: boolean = false;
  filters: FilterDto[] = [];
  currentAppliedFilters: FilterDto[] = []; // Track filters used in current view
  
displayedColumns = [
  { label: 'Adj Id', propertyName: 'detailedAdjSubId' },
  { label: 'Adjst Request Date', propertyName: 'adjRequestDate' },
  { label: 'GBS Recvd Date', propertyName: 'gbsReceivedDate' },
  { label: 'MMS#', propertyName: 'mms' },
  { label: 'CMF#', propertyName: 'cmf' },
  { label: 'Customer Name', propertyName: 'customerName' },
  { label: 'Requestor', propertyName: 'requestCreatedBy' },
  { label: 'Billing Site', propertyName: 'billingSite' },
  { label: 'Status', propertyName: 'statusName' },
  { label: 'GBS Assignee', propertyName: 'gbsAssignee' },
  { label: 'GBS Assignee Name', propertyName: 'gbsAssigneeName' },
  { label: 'Adj Type', propertyName: 'adjTypeDescription' },
  { label: 'Adjustment Reason', propertyName: 'adjReason' },
  { label: 'Adj Request', propertyName: 'adjReq' },
  { label: 'Description /Comment', propertyName: 'descriptionComment' },
  { label: 'Total Invoice', propertyName: 'totalInvoiceAmt' },
  { label: 'Total Correct Charges', propertyName: 'totalCorrectCharges' },
  { label: 'Net Adjustment Amount', propertyName: 'netAdjustmentAmount' },
  { label: 'AE/Sales Contact', propertyName: 'aeUser' },
  { label: 'WE Period', propertyName: 'wePeriod' },
  { label: 'Created', propertyName: 'recordCreationTimestamp' },
  { label: 'Modified', propertyName: 'requestUpdatedDate' },
  { label: 'Sent For Approval', propertyName: 'sentForApprovalDate' },
  { label: 'Sent To Corrections', propertyName: 'sentToCorrectionsDate' },
  { label: 'Completed', propertyName: 'completedDate' },
  { label: 'Statement Date', propertyName: 'statementDate' },
  { label: 'Statement No', propertyName: 'statementNumber' },
  { label: 'Statement Amt', propertyName: 'statementAmt' },
  //{ label: 'Adjustment Amt', propertyName: 'netAdjustmentAmount' },
  { label: 'Invoice No', propertyName: 'invoiceNumber' },
  //{ label: 'Invoice Amt', propertyName: 'invoiceAmt' },
  { label: 'Inv Adj Amt', propertyName: 'invAdjAmt' },
  { label: 'Rebill CMF', propertyName: 'rebillCMF' },
  { label: 'Rebill MMS', propertyName: 'rebillMMS' },
  { label: 'Rebill Customer Name', propertyName: 'rebillCustomerName' },
  { label: 'Rebill Statement No', propertyName: 'rebillStatementNo' },
  //{ label: 'Rebill Invoice No', propertyName: 'rebillInvoiceNo' },
  { label: 'Rebill Amount', propertyName: 'rebillAmount' },
  { label: 'GBS Billing Comments', propertyName: 'gbsBillingComments' },
  { label: 'Refund (Y/N)', propertyName: 'checkRefund' },
  { label: 'Remit Address', propertyName: 'checkRefundRemarks' },
  { label: 'Check Details', propertyName: 'checkDetails' },
  { label: 'Refund Status', propertyName: 'refundStatus' },
  { label: 'Salesforce Case Number', propertyName: 'salesforceCaseNumber' },
  { label: 'GBS Collections Comments', propertyName: 'gbsCollectionComments' },
    { label: 'Is PRS', propertyName: 'isPRS' },
    { label: 'Is Consolidated', propertyName: 'isConsolidated' },
  {
    label: 'Action',
    propertyName: 'icon',
    showSpinner: false,
    icons: [
      { toolTip: 'Download', icon: 'download', callFrom: 'download' },
      {toolTip:'Form PR-38 Download', icon: 'download_for_offline', callFrom: 'DownloadPR38', isDisabled: (element: any) => {
    const allowed = [
      BillingAdjustmentStatusEnum.Completed,
      BillingAdjustmentStatusEnum.CompletedRefundInfoNeeded,
      BillingAdjustmentStatusEnum.WaitingForApproval
    ];
    return !allowed.includes(element.status); 
  }},
      { toolTip: 'View Statement Details', icon: 'remove_red_eye', callFrom: 'view-invoice' },
      { toolTip: 'No Sla Breach', tooltipProperty: 'slaInfo', icon: 'warning' }
    ]
  }
];


  HistoryDisplayedColumns = [
    { label: 'ADJ REQ ID#', propertyName: 'adjReqId' },
    { label: 'Customer Name', propertyName: 'customerName' },
    { label: 'Creation Time', propertyName: 'recordCreationTimestamp' },
    { label: 'CMF', propertyName: 'cmf' },
    { label: 'MMS', propertyName: 'mms' },
    { label: 'Orig Stmt', propertyName: 'origStmt' },
    { label: 'Invoice Date', propertyName: 'invDate' },
    { label: 'WE Period', propertyName: 'wePeriod' },
    { label: 'PCS', propertyName: 'pcs' },
    { label: 'F25DomMail Current', propertyName: 'f25DomMail_Current' },
    { label: 'D49Fsc Current', propertyName: 'd49Fsc_Current' },
    { label: 'D90MinFee Current', propertyName: 'd90MinFee_Current' },
    { label: '99Misc Current', propertyName: '_99Misc_Current' },
    { label: 'F03Intl Current', propertyName: 'f03Intl_Current' },
    { label: 'Total Invoice', propertyName: 'totalInvoice' },
    { label: 'FSCRate Billed', propertyName: 'fscRateBilled' },
    { label: 'Correct FSC', propertyName: 'correctFSC' },
    { label: 'F25DomMail New', propertyName: 'f25DomMail_Adj' },
    { label: 'D49Fsc New', propertyName: 'd49Fsc_Adj' },
    { label: 'D90MinFee New', propertyName: 'd90MinFee_Adj' },
    { label: '99Misc New', propertyName: '_99Misc_Adj' },
    { label: 'F03Intl New', propertyName: 'f03Intl_Adj' },
    { label: 'Total Correct Charges', propertyName: 'totalCorrectCharges' },
    { label: 'F25DomMail Adj', propertyName: 'f25DomMail_Adj' },
    { label: 'D49Fsc Adj', propertyName: 'd49Fsc_Adj' },
    { label: 'D90MinFee Adj', propertyName: 'd90MinFee_Adj' },
    { label: '99Misc Adj', propertyName: '_99Misc_Adj' },
    { label: 'F03Intl Adj', propertyName: 'f03Intl_Adj' },
    { label: 'Total Adjustment', propertyName: 'totalAdjustment' },
    { label: 'Action', propertyName: 'billingAction' },
    {label : 'Billing Site', propertyName: 'billingSite'},
    {label : 'AE', propertyName: 'ae'},
    { label: 'Is PRS', propertyName: 'isPRS' },
    { label: 'Is Consolidated', propertyName: 'isConsolidated' }
  ];


  HistoryDisplayedColumnsGoodWill = [
    { label: 'ADJ REQ ID#', propertyName: 'adjReqId' },
    { label: 'Customer Name', propertyName: 'customerName' },
    { label: 'Creation Time', propertyName: 'recordCreationTimestamp' },
    { label: 'CMF', propertyName: 'cmf' },
    { label: 'MMS', propertyName: 'mms' },
    { label: 'Total Adjustment', propertyName: 'totalAdjustment' },
    { label: 'Action', propertyName: 'billingAction' },
    {label : 'Billing Site', propertyName: 'billingSite'},
    {label : 'AE', propertyName: 'ae'},
    { label: 'Is PRS', propertyName: 'isPRS' },
    { label: 'Is Consolidated', propertyName: 'isConsolidated' }
  ];

  displayedColumnKeys = this.HistoryDisplayedColumns.map(c => c.propertyName);

  @ViewChild(MatPaginator) paginator: MatPaginator | undefined;
  @ViewChild(MatSort) sort: MatSort | undefined;
  @ViewChild('modalTemplate') modalTemplate!: TemplateRef<any>;
  constructor(
      private router: Router,
    private batReportStatusService:RequestStatusService,
    private batRequestService: BatRequestService, // Inject BatRequestService for PDF download
    public dialog: MatDialog,private spinnerService: SpinnerService,
    private modalService: BsModalService,private toastr: ToastrService,private renderer: Renderer2,
    private cdr: ChangeDetectorRef,
    private sanitizer: DomSanitizer // Inject DomSanitizer
  ) {
  }

  ngOnInit(): void {
       this.isDetailedReports = this.router.url.includes('detailed-reports')
    this.spinnerService.showSpinner();
    this.onSubmit(1,10);
  }

   openAcceptOrRejectDialog(e : any,template: TemplateRef<any>) {
    if(e.details.adjTypeDescription === "Goodwill"){
      this.isGoodWillRequest = true;
      this.displayedColumnKeys = this.HistoryDisplayedColumnsGoodWill.map(c => c.propertyName);
    }else{
      this.isGoodWillRequest = false;
      this.displayedColumnKeys = this.HistoryDisplayedColumns.map(c => c.propertyName);
    }
    if(e.callFrom == 'download'){
      if(e.details.isFileUploaded)
        {
      this.spinnerService.showSpinner();
      this.batReportStatusService.DownloadUploadedFiles(e.details.adjReqId)
        .subscribe({
          next: data => {
            const filename = `AdjustmentRequest_${e.details.adjReqId}.zip`;  
            const blob = new Blob([data], { type: 'application/zip' });
            saveAs(blob, filename);
            this.spinnerService.hideSpinner();
            this.toastr.success('File Downloaded Successfully', 'Success');
          },
          error: () => {
            this.spinnerService.hideSpinner();
            this.toastr.error('Error downloading file', 'Error');
          }
        });
    }
    else{
      this.toastr.warning('No Files Uploaded', 'warning');
    }
     // this.GetInvoiceDownloadFile(e.details.adjReqId)
    }
    else if(e.callFrom == 'view-invoice'){
    this.GetBillingAdjustmentStatusRequestDetailReports(template, e.details.adjReqId)
    }
    else if(e.callFrom == 'view-tooltip'){      
    }
    else if(e.callFrom == 'DownloadPR38'){
      const downloadToastr = this.toastr.info('Form PR-38 Downloading...', 'Information', {
      timeOut: 0,
      extendedTimeOut: 0,
      closeButton: false,
      disableTimeOut: true
    });
    var jsondata= {
      adjReqId: e.details.adjReqId,
      adjSubId:  e.details?.adjSubId || 0,
      detailsId: e.details?.detailsId || 0
    }
  this.batReportStatusService.exportFormPR38(jsondata)
    .subscribe({
      next: (fileData: Blob) => {
        const amount = e.details.netAdjustmentAmount;
        const formattedAmount = amount < 0 
            ? `(${Math.abs(amount)})` 
            : amount;

        const filename = `PR38_${e.details.adjReqId}_${e.details.customerName}-$${formattedAmount}.xlsx`;
        const blob = new Blob([fileData], { 
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
        });
        saveAs(blob, filename);
        this.toastr.clear(downloadToastr.toastId);
        this.toastr.success('Form PR-38 Downloaded Successfully', 'Success');
      },
      error: () => {
        this.toastr.clear(downloadToastr.toastId);
        this.toastr.error('Error downloading file', 'Error');
      }
    });
    }
    }
 
  openAddModal(template: TemplateRef<any>) {
    this.adminModalRef = this.modalService.show(template, { backdrop: "static" });
   }
   allowOnlyNumbers(event: KeyboardEvent): void {
  const charCode = event.charCode;
  const input = event.target as HTMLInputElement;

  // Allow only digits (0-9) and limit to 12 characters
  if ((charCode < 48 || charCode > 57) || input.value.length >= 12) {
    event.preventDefault();
  }
}


   onReportTypeChange(event: any) {
  const selectedValue = event.value;

  if (selectedValue === 1) {
    this.reportTypeFlag = 'BAT';
  } else if (selectedValue === 2) {
    this.reportTypeFlag = 'DigitalCopies';
  }
this.cdr.detectChanges();
}



   closePopup() {
    this.adminModalRef.hide();
   }
   
   displayedColumnsList() : any[] {
    return this.isGoodWillRequest ? this.HistoryDisplayedColumnsGoodWill :  this.HistoryDisplayedColumns
    }

    onSubmit(pageIndex: number = 1, pageSize: number = 10, filters: FilterDto[] = [], isRefresh: boolean = false) {
  this.spinnerService.showSpinner();
  
  if (isRefresh) {
    pageIndex = 1;
    pageSize = 10;
    this.pageSize = 10;
    this.currentAppliedFilters = [];
    filters = [];
  }
  
  const isFilterChange = filters.length > 0;
  
  if (isFilterChange) {
    this.currentAppliedFilters = [...filters];
    pageIndex = 1;
  } else if (this.currentAppliedFilters.length > 0) {
    filters = [...this.currentAppliedFilters];
  } else {
    console.log('Simple pagination change - no filters');
  }
  
  
  this.filters = filters.map(f => ({
    column: f.column,
    operator: f.operator || 'contains',
    value: f.value?.toString() || ''
  }));

  const statusFilter = this.filters.find(f => f.column === 'statusName' || f.column === 'statusDesc');
  
  let status: number[];
  if (statusFilter) {
    status = statusFilter.value.split(',').map(v => parseInt(v.trim()));
  } else {
    status = this.requestReportSearch?.statusType == 0
      ? [1,3,4,5,6,7,8,9,10,11,13,14,15,16,17]
      : [this.requestReportSearch?.statusType];
  }

  this.formValue = { ...this.requestReportSearch };
  this.formValue.reportType = '1';
  this.formValue.startDate = formatDateRange(this.requestReportSearch.startDate);
  this.formValue.endDate = formatDateRange(this.requestReportSearch.endDate, true);
  this.formValue.StatusId = status;
  this.formValue.filters = this.filters;

  this.formValue.PageNumber = pageIndex;
  this.formValue.PageSize = pageSize;

  this.batReportStatusService.getReportByDateRange(this.formValue).subscribe(
    (result) => {
      
      this.requestReportSearch.startDate = this.formValue.startDate;
      this.requestReportSearch.endDate = this.formValue.endDate;

      const data = result.billingAdjustmentDetails;
      this.dataSource = new MatTableDataSource(data);
      this.totalCount = result.totalCount;

      this.pageSize = pageSize;

      this.dataSource.data.forEach(x => {
        x.secondLevelApprover = x.secondLevelApprover || '--';
        x.secondLevelRemarks = x.secondLevelRemarks || '--';

        x.adjRequestDate = formatDate(x.adjRequestDate,'MM/dd/yyyy', "en-US");
        x.requestUpdatedDate = x.requestUpdatedDate ? formatDate(x.requestUpdatedDate,'MM/dd/yyyy', "en-US") : '--';
        x.gbsReceivedDate = x.gbsReceivedDate ? formatDate(x.gbsReceivedDate,'MM/dd/yyyy', "en-US") : '--';
        x.sentForApprovalDate = x.sentForApprovalDate ? formatDate(x.sentForApprovalDate,'MM/dd/yyyy', "en-US") : '--';
        x.sentToCorrectionsDate = x.sentToCorrectionsDate ? formatDate(x.sentToCorrectionsDate,'MM/dd/yyyy', "en-US") : '--';
        x.statementDate = x.statementDate ? formatDate(x.statementDate,'MM/dd/yyyy', "en-US") : '--';
        x.completedDate = x.status === 'Completed' ? formatDate(x.completedDate,'MM/dd/yyyy', "en-US") : '--';
        x.slaInfo = x.miApproval.flag ? `${x.miApproval.days} days past SLA` : x.gbsApproval.flag ? `${x.gbsApproval.days} days past SLA` : '';
        x.gbsCollectionComments = x.gbsAssignee == 'Collections' ? x.gbsCollectionComments : '--';
        x.gbsBillingComments = x.gbsAssignee == 'Billing' || x.gbsAssignee == 'GBS District Manager' ? x.gbsBillingComments : '--';
        x.isPRS = x.isPRS ? 'Yes' : 'No';
        x.isConsolidated = x.isConsolidated ? 'Yes' : 'No';
        x.recordCreationTimestamp= x.recordCreationTimestamp ? formatDate(x.recordCreationTimestamp,'MM/dd/yyyy', "en-US") : '--';
      });

      this.spinnerService.hideSpinner();
    },
    () => {
      this.spinnerService.hideSpinner();
    }
  );
}

  GetBillingAdjustmentStatusRequestDetailReports(template: TemplateRef<any>, adjReqId){
    this.batReportStatusService.GetBillingAdjustmentStatusRequestDetailReports(adjReqId)
    .subscribe((result) => {
      this.panels = result;
      if(this.adminModalRef) {
        this.adminModalRef.hide();
       }
      this.panels.forEach(x => {
        x.invDate = formatDate(x.invDate,'MM/dd/yyyy', "en-US");
        x.wePeriod = formatDate(x.wePeriod,'MM/dd/yyyy', "en-US");
        x.recordCreationTimestamp = formatDate(x.recordCreationTimestamp,'MM/dd/yyyy',"en-US");
      });  
      this.adminModalRef = this.modalService.show(template, { backdrop: "static" });
    }, (error) => {
    console.log(error)
    })
  }

exportXLSX() {
  var status = this.requestReportSearch?.statusType == 0
    ? [1, 3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 14, 15, 16, 17]
    : [this.requestReportSearch?.statusType];

  const filters = {
    ...this.requestReportSearch,
    reportType: '1',
    startDate: formatDateRange(this.requestReportSearch.startDate),
    endDate: formatDateRange(this.requestReportSearch.endDate, true),
    StatusId: status,
    PageNumber: 1,              
    PageSize: 0,               
    isFromExportExcel: true,
    filters: this.filters
  };

  const downloadToastr = this.toastr.info('Report Downloading...', 'Information', {
    timeOut: 0,
    extendedTimeOut: 0,
    closeButton: false,
    disableTimeOut: true
  });
this.batReportStatusService.exportReportToExcel(filters)
  .subscribe({
    next: (fileData: Blob) => {
      const filename = `RequestStatusReport_${new Date().toISOString().split('T')[0]}.xlsx`;
      const blob = new Blob([fileData], { 
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
      });
      saveAs(blob, filename);

      this.toastr.clear(downloadToastr.toastId);
      this.toastr.success('Report Downloaded Successfully', 'Success');
    },
    error: () => {
      this.toastr.clear(downloadToastr.toastId);
      this.toastr.error('Error downloading file', 'Error');
    }
  });
}

  /**
   * Format monetary values with $ symbol and comma separators
   */
  private formatCurrency(value: any): string {
    if (value == null || value === '' || isNaN(Number(value))) {
      return '';
    }
    const numValue = Number(value);
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(numValue);
  }

  async onGenerate() {
    if (this.reportTypeFlag === 'DigitalCopies') {
      // Always trim spaces from Adjustment Request ID before validation
      const adjReqId = (this.requestReportSearch.adjReqId || '').trim();
      this.requestReportSearch.adjReqId = adjReqId; // update the value in the form as well
      this.adjReqIdErrorMessage = '';
      if (!adjReqId) {
        this.adjReqIdError = true;
        this.pdfSrc = null;
        if (this.blobUrl) {
          URL.revokeObjectURL(this.blobUrl);
          this.blobUrl = null;
        }
        this.adjReqIdErrorMessage = 'Adjustment Request ID cannot be blank, null, or empty. Please enter a value before generating.';
        return;
      }
      // Use the correct service for validation
      try {
        const isValid = await this.batReportStatusService.validateAdjReqId(adjReqId);
        if (!isValid) {
          this.adjReqIdError = true;
          this.pdfSrc = null;
          this.adjReqIdErrorMessage = 'Invalid Adjustment Request ID: not found in system.';
          return;
        } else {
          this.adjReqIdError = false;
          this.adjReqIdErrorMessage = '';
        }
      } catch (err) {
        this.adjReqIdError = true;
        this.pdfSrc = null;
        this.adjReqIdErrorMessage = 'Invalid Adjustment Request ID: not found in system.';
        return;
      }
    }

    // Show spinner for PDF generation
    this.spinnerService.showSpinner();
    this.isLoading = true;
    try {
      // Fetch invoice data from API
      const adjReqId = this.requestReportSearch.adjReqId;
      const invoiceData = await this.batReportStatusService.getInvoiceDataForAdjReqId(adjReqId);
      if (!invoiceData) {
        this.spinnerService.hideSpinner();
        this.toastr.error('Failed to fetch invoice data for PDF.', 'Error');
        this.isLoading = false;
        return;
      }
      import('jspdf').then(jsPDFModule => {
        import('jspdf-autotable').then(autoTableModule => {
          const jsPDF = jsPDFModule.jsPDF;
          const doc = new jsPDF({ orientation: 'landscape', unit: 'pt', format: 'a4' });
          // Set PDF metadata title for Chrome/Edge/Adobe compatibility
          if (this.reportTypeFlag === 'DigitalCopies') {
            doc.setProperties({
              title: `Digital_Copy_${adjReqId || ''}`
            });
          } else {
            doc.setProperties({
              title: 'AdjustmentRequest_Sample'
            });
          }
          const pageWidth = doc.internal.pageSize.getWidth();
          const pageHeight = doc.internal.pageSize.getHeight();
          // UPS brown and yellow
          const brown: [number, number, number] = [53, 28, 21]; // #351c15
          const yellow: [number, number, number] = [255, 204, 0]; // #ffcc00
          let y = 36;
          // Header
          doc.setFillColor(brown[0], brown[1], brown[2]);
          doc.setDrawColor(brown[0], brown[1], brown[2]);
          doc.rect(30, y, pageWidth-60, 28, 'F');
          doc.setFont('helvetica', 'bold');
          doc.setFontSize(10.4); // 13 * 0.8
          doc.setTextColor(yellow[0], yellow[1], yellow[2]);
          doc.text('UPS MAIL INNOVATIONS  ACCOUNTS RECEIVABLE ADJUSTMENT AUTHORIZATION', pageWidth / 2, y+18, { align: 'center' });
          // Add menu/filename at the top right for DigitalCopies
          if (this.reportTypeFlag === 'DigitalCopies') {
            const menuLabel = `Digital_Copy_${adjReqId || ''}`;
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(10);
            doc.setTextColor(80, 80, 80);
            doc.text(menuLabel, pageWidth - 40, y + 18, { align: 'right' });
          }
          y += 38;
          // Description (left)
          doc.setFont('helvetica', 'bold');
          doc.setFontSize(8); // 10 * 0.8
          doc.setTextColor(brown[0], brown[1], brown[2]);
          doc.text('Description of adjustment/error & root cause :', 40, y);
          doc.setFont('helvetica', 'normal');
          doc.setFontSize(8);
          doc.setTextColor(0,0,0);
          let descLines = doc.splitTextToSize(invoiceData.description || '', 350);
          doc.text(descLines, 40, y+13);

          // Declare leftColBottom and controlsY before conditional blocks
          let leftColBottom: number;
          let controlsY: number;

          // Controls/ corrections - MAKE THIS CONDITIONAL
          if (!invoiceData.isBulkRequest) {
            // Controls (left, below desc)
            controlsY = y + 13 + descLines.length*10 + 14;
            doc.setDrawColor(brown[0], brown[1], brown[2]);
            doc.line(40, controlsY-7, 390, controlsY-7);
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(8);
            doc.setTextColor(brown[0], brown[1], brown[2]);
            doc.text('Controls/ corrections put in place to prevent recurrence of issue :', 40, controlsY);
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(8);
            doc.setTextColor(0,0,0);
            // Add text wrapping like description field
            let controlsLines = doc.splitTextToSize(invoiceData.controls || '', 350);
            doc.text(controlsLines, 40, controlsY+13);
            
            // Update leftColBottom calculation to account for wrapped text
            leftColBottom = controlsY + 13 + controlsLines.length * 10 + 6;
          } else {
            // For bulk requests, position additional fields directly after description
            controlsY = y + 13 + descLines.length*10 + 14; // Use same calculation as base
            
            // Add new text field beneath Description with space above (for bulk requests only)
            let additionalFieldY = controlsY + 20; // 20pt space above the new field
            doc.setDrawColor(brown[0], brown[1], brown[2]);
            doc.line(40, additionalFieldY - 7, 390, additionalFieldY - 7);
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(8);
            doc.setTextColor(brown[0], brown[1], brown[2]);
            doc.text('Special Instructions:', 40, additionalFieldY);
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(8);
            doc.setTextColor(0, 0, 0);
            // Split text to fit within the column width and handle empty/null values
            let specialInstructionsText = invoiceData.specialInstructions || 'No special instructions provided';
            let additionalInfoLines = doc.splitTextToSize(specialInstructionsText, 350);
            doc.text(additionalInfoLines, 40, additionalFieldY + 13);
            
            // Add another text field beneath Special Instructions with space above
            let secondAdditionalFieldY = additionalFieldY + 13 + additionalInfoLines.length * 10 + 20; // 20pt space above, accounting for actual text height
            doc.setDrawColor(brown[0], brown[1], brown[2]);
            doc.line(40, secondAdditionalFieldY - 7, 390, secondAdditionalFieldY - 7);
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(8);
            doc.setTextColor(brown[0], brown[1], brown[2]);
            doc.text('# of Customers:', 40, secondAdditionalFieldY);
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(8);
            doc.setTextColor(0, 0, 0);
            // Split text to fit within the column width and handle empty/null values
            let customerCountText = invoiceData.customerCount || 'Not specified';
            let secondAdditionalInfoLines = doc.splitTextToSize(customerCountText, 350);
            doc.text(secondAdditionalInfoLines, 40, secondAdditionalFieldY + 13);
            
            // Update leftColBottom to include both new fields with accurate spacing calculation
            leftColBottom = secondAdditionalFieldY + 13 + secondAdditionalInfoLines.length * 10 + 6;
          }

          // Adjustment reason (right) - this remains always visible
          let adjX = 420, adjW = pageWidth-420-40;
          doc.setFont('helvetica', 'bold');
          doc.setFontSize(8);
          doc.setTextColor(brown[0], brown[1], brown[2]);
          doc.text('Adjustment reason', adjX, y);
          doc.setFont('helvetica', 'normal');
          doc.setFontSize(8);
          doc.setTextColor(0,0,0);
          let adjReasonLines = (invoiceData.adjustmentReasons || []).map(r=>doc.splitTextToSize(r || '', adjW-20)).flat();
          doc.text(adjReasonLines, adjX, y+13);
          // Declare checkRefundY outside the conditional block so it's always defined
          let checkRefundY: number = y+13+adjReasonLines.length*10+6; // Default value

          // Checkboxes (clean shapes) - CONDITIONAL
          if (!invoiceData.isBulkRequest) {
            let checkboxY = y+13+adjReasonLines.length*10+6;
            let checkboxRows = [
              { label: 'Billed within 6 months', value: invoiceData.billedSixMonths },
              { label: 'Disputed within 6 months', value: invoiceData.disputedSixMonths },
              { label: 'Billing Edit required', value: invoiceData.billingEditRequired },
              { label: 'Billing Edit completed', value: invoiceData.billingEditCompleted }
            ];
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(8);
            doc.setTextColor(0,0,0);
            checkboxRows.forEach((row, idx) => {
              let yPos = checkboxY + idx*18;
              // Set label to UPS brown
              doc.setFont('helvetica', 'normal');
              doc.setFontSize(8);
              doc.setTextColor(brown[0], brown[1], brown[2]);
              doc.text(row.label, adjX, yPos+8);
              // Draw single box
              doc.setDrawColor(brown[0], brown[1], brown[2]);
              doc.setFillColor(255,255,255);
              doc.rect(adjX+170, yPos, 24, 18, 'FD');
              // Map value to Y/N/N/A
              let val = (row.value || '').toString().trim().toLowerCase();
              let displayVal = '';
              let color = brown;
              if (val === 'yes') {
                displayVal = 'Y';
                color = [0, 150, 0]; // green
              } else if (val === 'no') {
                displayVal = 'N';
                color = [150, 0, 0]; // red
              } else if (val === 'n/a' || val === 'na') {
                displayVal = 'N/A';
                color = [120, 120, 120]; // gray
              }
              doc.setFont('helvetica', 'bold');
              doc.setFontSize(13);
              doc.setTextColor(color[0], color[1], color[2]);
              // Center value in the single box
              doc.text(displayVal, adjX+182, yPos+12, {align:'center'});
            });
            
            // Check refund - ALSO CONDITIONAL (moved inside the if block)
            checkRefundY = checkboxY + checkboxRows.length*18 + 8;
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(8);
            doc.setTextColor(brown[0], brown[1], brown[2]);
            doc.text('Check refund', adjX, checkRefundY);
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(8);
            doc.setTextColor(0,0,0);
            let checkRefundLines = doc.splitTextToSize(invoiceData.checkRefund || '', adjW-150);
            doc.text(checkRefundLines, adjX+100, checkRefundY);
            
            // Check refund comments (positioned below check refund with proper spacing) - ALSO CONDITIONAL
            let checkRefundCommentsY = checkRefundY + Math.max(checkRefundLines.length * 10, 14) + 12;
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(8);
            doc.setTextColor(brown[0], brown[1], brown[2]);
            doc.text('Check refund comments', adjX, checkRefundCommentsY);
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(8);
            doc.setTextColor(0,0,0);
            let checkRefundCommentsText = invoiceData.checkRefundComments || 'No comments available';
            let checkRefundCommentsLines = doc.splitTextToSize(checkRefundCommentsText, adjW-150);
            doc.text(checkRefundCommentsLines, adjX+100, checkRefundCommentsY);
            
            // Update rightColEnd calculation to include check refund sections
            var rightColEnd = checkRefundCommentsY + Math.max(checkRefundCommentsLines.length * 10, 14) + 20;
          } else {
            // If not a bulk request, set rightColEnd to just after adjustment reasons
            var rightColEnd = y+13+adjReasonLines.length*10+40; // Add some padding
          }
          
          // ADJ REQ ID# (positioned conditionally based on whether check refund sections exist)
          doc.setFont('helvetica', 'bold');
          doc.setFontSize(8);
          doc.setTextColor(brown[0], brown[1], brown[2]);
          let adjReqIdY = invoiceData.isBulkRequest ? checkRefundY-12 : y+13+adjReasonLines.length*10+20;
          doc.text('ADJ REQ ID#', adjX+adjW-120, adjReqIdY);
          doc.setFont('helvetica', 'normal');
          doc.setFontSize(8);
          doc.setTextColor(0,0,0);
          doc.text(String(invoiceData.adjReqId || ''), Number(adjX+adjW-30) || 10, Number(adjReqIdY) || 10, {align:'right'});
          
          // Calculate the bottom Y position after all top content
          let contentBottom = Math.max(leftColBottom, rightColEnd);

          // If the table would overlap with the content, start a new page
          let minTableY = contentBottom + 32; // add more space between content and heading
          let tableHeadingY = minTableY;
          // If the heading or table would overlap the page bottom, start a new page
          if (tableHeadingY + 32 > pageHeight - 60) { // ensure at least 32pt below heading
            doc.addPage();
            tableHeadingY = 40; // top margin for new page
          }

          // Draw the heading first, then table below
          doc.setFont('helvetica', 'bold');
          doc.setFontSize(9.6); // 12 * 0.8
          doc.setTextColor(brown[0], brown[1], brown[2]);
          doc.text('BILLING ADJUSTMENT SUMMARY', 40, tableHeadingY);
          // Table columns as in screenshot - MAKE HEADERS CONDITIONAL
          let tableHead: string[][];
          let tableFoot: string[][]; // Define tableFoot for footer row(s)
          if (!invoiceData.isBulkRequest) {
            // Non-bulk request: show all headers including the conditional ones
            tableHead = [[
              '', 'MMS#', 'CMF#', 'Customer Name', 'Orig Stmt #', 'Inv date', 'WE Period', 'TOTAL INVOICE', 'CORRECT CHARGES', 'NET ADJUSTMENT', 'ACTION', 'Billing Site', 'AE'
            ]];
            
            // Initialize footer with empty strings
            let footerRow = Array(13).fill(''); // 13 columns for non-bulk request
            footerRow[6] = 'TOTAL ADJUST'; // Position 6 for the label
            
            // Fill positions 7, 8, 9 from invoiceData.summaryFoot array
            if (invoiceData.summaryFoot && Array.isArray(invoiceData.summaryFoot)) {
              // Position 7: TOTAL INVOICE
              if (invoiceData.summaryFoot[7] != null && invoiceData.summaryFoot[7] !== '') {
                const totalInvoiceValue = parseFloat(invoiceData.summaryFoot[7]);
                footerRow[7] = !isNaN(totalInvoiceValue) ? this.formatCurrency(totalInvoiceValue) : invoiceData.summaryFoot[7];
              }
              
              // Position 8: CORRECT CHARGES
              if (invoiceData.summaryFoot[8] != null && invoiceData.summaryFoot[8] !== '') {
                const correctChargesValue = parseFloat(invoiceData.summaryFoot[8]);
                footerRow[8] = !isNaN(correctChargesValue) ? this.formatCurrency(correctChargesValue) : invoiceData.summaryFoot[8];
              }
              
              // Position 9: NET ADJUSTMENT
              if (invoiceData.summaryFoot[9] != null && invoiceData.summaryFoot[9] !== '') {
                const netAdjustmentValue = parseFloat(invoiceData.summaryFoot[9]);
                footerRow[9] = !isNaN(netAdjustmentValue) ? this.formatCurrency(netAdjustmentValue) : invoiceData.summaryFoot[9];
              }
            } else {
              // Fallback: use individual properties if summaryFoot array is not available
              if (invoiceData.totalInvoice != null && invoiceData.totalInvoice !== '') {
                const totalInvoiceValue = parseFloat(invoiceData.totalInvoice);
                footerRow[7] = !isNaN(totalInvoiceValue) ? this.formatCurrency(totalInvoiceValue) : invoiceData.totalInvoice;
              }
              
              if (invoiceData.correctCharges != null && invoiceData.correctCharges !== '') {
                const correctChargesValue = parseFloat(invoiceData.correctCharges);
                footerRow[8] = !isNaN(correctChargesValue) ? this.formatCurrency(correctChargesValue) : invoiceData.correctCharges;
              }
              
              if (invoiceData.netAdjustment != null && invoiceData.netAdjustment !== '') {
                const netAdjustmentValue = parseFloat(invoiceData.netAdjustment);
                footerRow[9] = !isNaN(netAdjustmentValue) ? this.formatCurrency(netAdjustmentValue) : invoiceData.netAdjustment;
              }
            }
            
            tableFoot = [footerRow];
          } else {
            // Bulk request: exclude CMF#, Orig Stmt #, Inv date, WE Period, TOTAL INVOICE, CORRECT CHARGES, and ACTION but KEEP Billing Site and AE, and add Adjustment Method
            tableHead = [[
              '', 'MMS#', 'Customer Name', 'Amount', 'Billing Site', 'AE', 'Adjustment Method', 'Check Request', 'Remit Address'
            ]];
            
            // Initialize footer for bulk request (9 columns now - increased from 8)
            let footerRow = Array(9).fill('');
            footerRow[2] = 'TOTAL ADJUST'; // Position 2 for the label in filtered array
            
            // For bulk requests, fill position 3 (AMOUNT only in filtered array)
            if (invoiceData.summaryFoot && Array.isArray(invoiceData.summaryFoot)) {
              // Map from original position 9 (NET ADJUSTMENT) -> filtered position 3 (AMOUNT)
              if (invoiceData.summaryFoot[9] != null && invoiceData.summaryFoot[9] !== '') {
                const netAdjustmentValue = parseFloat(invoiceData.summaryFoot[9]);
                footerRow[3] = !isNaN(netAdjustmentValue) ? this.formatCurrency(netAdjustmentValue) : invoiceData.summaryFoot[9];
              }
            } else {
              // Fallback for bulk requests
              if (invoiceData.netAdjustment != null && invoiceData.netAdjustment !== '') {
                const netAdjustmentValue = parseFloat(invoiceData.netAdjustment);
                footerRow[3] = !isNaN(netAdjustmentValue) ? this.formatCurrency(netAdjustmentValue) : invoiceData.netAdjustment;
              }
            }
            
            tableFoot = [footerRow];
          }

          // Add row labels (A, B, C) as first column and format currency for columns - ADJUST COLUMN INDICES
          const tableBody = invoiceData.summary.map(row => {
            if (!invoiceData.isBulkRequest) {
              // Non-bulk request: format currency for columns 7, 8, 9 (TOTAL INVOICE, CORRECT CHARGES, NET ADJUSTMENT)
              return row.map((cell, index) => {
                if ((index === 7 || index === 8 || index === 9) && cell != null && cell !== '') {
                  const numValue = parseFloat(cell);
                  return !isNaN(numValue) ? this.formatCurrency(numValue) : cell;
                }
                return cell;
              });
            } else {
              // Bulk request: filter out columns but KEEP Billing Site (11), AE (12), and add Adjustment Method (13)
              // Remove columns: CMF# (2), Orig Stmt # (4), Inv date (5), WE Period (6), TOTAL INVOICE (7), CORRECT CHARGES (8), ACTION (10)
              const filteredRow = row.filter((cell, index) => 
                index !== 2 && index !== 4 && index !== 5 && index !== 6 && index !== 7 && index !== 8 && index !== 10
              );
              
              // After filtering, AMOUNT is at index 3
              return filteredRow.map((cell, index) => {
                if (index === 3 && cell != null && cell !== '') {
                  const numValue = parseFloat(cell);
                  return !isNaN(numValue) ? this.formatCurrency(numValue) : cell;
                }
                return cell;
              });
            }
          });

                   
        

          // Define dynamic columnStyles based on request type
          let columnStyles: any = {};
          if (!invoiceData.isBulkRequest) {
            columnStyles = {
              7: { halign: 'right' }, // TOTAL INVOICE
              8: { halign: 'right' }, // CORRECT CHARGES
              9: { halign: 'right' }  // NET ADJUSTMENT
            };          
          } else {
            columnStyles = {
              3: { halign: 'right' }  // AMOUNT (moved to index 3)
            };
          }

          // Remove the temporary document calculation and just render the table once
          // Single table render with proper pagination handling
          autoTable(doc, {
            startY: tableHeadingY + 8,
            head: tableHead,
            body: tableBody,
            foot: tableFoot,
            theme: 'grid',
            headStyles: { fillColor: yellow, textColor: brown, fontStyle: 'bold', fontSize: 8, halign: 'center' },
            bodyStyles: { fontSize: 8, fillColor: [255,255,255], textColor: brown, halign: 'center', valign: 'middle' },
            footStyles: { fillColor: yellow, textColor: brown, fontStyle: 'bold', fontSize: 6, halign: 'center' },
            columnStyles: columnStyles,
            margin: { left: 30, right: 30 },
            tableWidth: 'auto',
            styles: { cellPadding: 2.4, lineColor: brown, lineWidth: 0.5 },
            showHead: 'everyPage', // Show header on every page
            showFoot: 'lastPage', // Show footer only on last page
            pageBreak: 'auto', // Allow automatic page breaks
            //rowPageBreak : 'auto',
            // pageBreakBefore: function(cursor, doc) {
            //   // Only break if we're getting close to the bottom of the page
            //   return cursor.y >= pageHeight - 100;
            // },
            // pageBreakBefore: function(cursor, doc) {
            //   // Correct parameters: cursor has y property, doc is the document
            //   return cursor.y >= pageHeight - 120; // Break when close to bottom
            // },
            didDrawPage: function(data) {
              // Add page numbers for multi-page tables (starting from page 2)
              if (data.pageNumber > 1) {
                doc.setFont('helvetica', 'normal');
                doc.setFontSize(8);
                doc.setTextColor(80, 80, 80);
                doc.text(`Page ${data.pageNumber}`, pageWidth - 50, pageHeight - 30, { align: 'right' });
              }
            },
          });

          // Get the final Y position after the table
          let afterTableY = (doc as any).lastAutoTable.finalY + 14;

          // Check if we need to add a new page for the bottom content
          const remainingSpace = pageHeight - afterTableY;
          const requiredSpaceForBottomContent = 200; // Estimate space needed for approval comments, circles, etc.

          if (remainingSpace < requiredSpaceForBottomContent) {
            doc.addPage();
            afterTableY = 40; // Start from top of new page
          }

          // Continue with approval comments and other content...
          // Approval Comments (replacing the approval thresholds box)
          let approvalCommentsY = afterTableY + 14;
          doc.setFont('helvetica', 'bold');
          doc.setFontSize(9.6); // 12 * 0.8
          doc.setTextColor(brown[0], brown[1], brown[2]);
          doc.text('APPROVAL COMMENTS', 40, approvalCommentsY);

          // Draw underline manually
          const approvalCommentsTextWidth = doc.getTextWidth('APPROVAL COMMENTS');
          doc.setDrawColor(brown[0], brown[1], brown[2]);
          doc.setLineWidth(1);
          doc.line(40, approvalCommentsY+3, 40+approvalCommentsTextWidth, approvalCommentsY+3);

          // Approval comments content
          doc.setFont('helvetica', 'normal');
          doc.setFontSize(8);
          doc.setTextColor(0,0,0);
          
          let secondLevelComment = invoiceData.SecondLevelRemrks || '';
          let approvalCommentsText = invoiceData.approvalComments || '';
          if (approvalCommentsText || secondLevelComment) {
            approvalCommentsText = `1st level comments : ${approvalCommentsText || 'N/A'}\n2nd level comments : ${secondLevelComment || 'N/A'}`;
          }
          if (!approvalCommentsText) {
            approvalCommentsText = 'No approval comments available';
          }
          let approvalCommentsLines = doc.splitTextToSize(approvalCommentsText, 400);
          doc.text(approvalCommentsLines, 40, approvalCommentsY+16);

          // Calculate the bottom Y position for the approval comments section
          let approvalCommentsBottomY = approvalCommentsY + 16 + Math.max(approvalCommentsLines.length * 10, 20);

          // Rest of the content continues as before...
          // Color coding legend/disclaimer
          let legendY = approvalCommentsBottomY + 12;
          doc.setFont('helvetica', 'bold');
          doc.setFontSize(8);
          doc.setTextColor(brown[0], brown[1], brown[2]);
          doc.text('APPROVAL STATUS COLOR LEGEND:', 40, legendY);

          // Green indicator - properly aligned
          doc.setFillColor(46, 204, 113);
          doc.setDrawColor(brown[0], brown[1], brown[2]);
          doc.circle(60, legendY + 15, 7, 'FD');
          doc.setFont('helvetica', 'normal');
          doc.setFontSize(8);
          doc.setTextColor(0, 0, 0);
          doc.text('Green = Stage Completed/Approved', 75, legendY + 18);

          // White indicator - properly aligned
          doc.setFillColor(255, 255, 255);
          doc.setDrawColor(brown[0], brown[1], brown[2]);
          doc.circle(60, legendY + 30, 7, 'FD');
          doc.text('White = Stage Pending/Awaiting Action', 75, legendY + 33);

          approvalCommentsBottomY = legendY + 45; // Update bottom position
          
          // Approval Circles and right-side content (horizontal alignment, UPS theme, no overlap)
          // Position to the right of the approval comments, at the same Y level
          const circleRadius = 36;
          // Position circles to the right of the approval comments section
          const rightSectionX = 500; // Fixed position to the right
          const rightSectionY = approvalCommentsY - 10;
          const circleColors = [
            { fill: yellow, border: brown },
            { fill: [255, 240, 180], border: brown },
            { fill: [255, 240, 180], border: brown },
            { fill: [255, 240, 180], border: brown }
          ];
          // Draw circles in a row
          const numCircles = invoiceData.approvalCircles.length;
          const totalCirclesWidth = numCircles * (circleRadius * 2) + (numCircles - 1) * 24;
          const circlesStartX = rightSectionX;
          const circlesY = rightSectionY + circleRadius;

          invoiceData.approvalCircles.forEach((c, i) => {
            const cx = circlesStartX + i * (circleRadius * 2 + 24);
            const cy = circlesY;

            // Color coding based on status instead of showing text
            let circleColor = circleColors[i];
            if (c.checked) {
              // YES status - Green fill for approved
              circleColor = { fill: [46, 204, 113], border: brown }; // Green for approved
            } else if (c.status && c.status.toLowerCase() === 'no') {
              // NO status - Red fill for rejected
              circleColor = { fill: [231, 76, 60], border: brown }; // Red for rejected
            } else {
              // Pending/No response - White fill
              circleColor = { fill: [255, 255, 255], border: brown }; // White for pending
            }

            doc.setDrawColor(circleColor.border[0], circleColor.border[1], circleColor.border[2]);
            doc.setFillColor(circleColor.fill[0], circleColor.fill[1], circleColor.fill[2]);
            doc.circle(cx, cy, circleRadius, 'FD');
            // Dynamically adjust font size for label to fit inside the circle
            let labelFontSize = 13;
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(labelFontSize);
            let labelWidth = doc.getTextWidth(c.label);
            while (labelWidth > (circleRadius * 1.7) && labelFontSize > 7) { // 1.7 to allow for padding
              labelFontSize -= 0.5;
              doc.setFontSize(labelFontSize);
              labelWidth = doc.getTextWidth(c.label);
            }
            doc.setTextColor(brown[0], brown[1], brown[2]);
            doc.text(c.label, cx, cy+6, {align:'center'});

            // No text shown - color indicates status
            // Green = Approved, Red = Rejected, Amber = Pending
          });

          // Draw Requestor and date directly below the circles, centered under the first circle
          // Move Requestor and date below the approval circles, centered under the first circle
          const firstCircleCx = circlesStartX;
          const lastCircleCx = circlesStartX + (numCircles - 1) * (circleRadius * 2 + 24);
          const circlesBottomY = circlesY + circleRadius + 8; // 8pt below the bottom of circles
          
          // Add "Hello" text with extra space above requestor
          const secondCircleCx = circlesStartX + (circleRadius * 2 + 24); // Position of second circle center (MI Internal, always index 1)
          const gbsCircleCx = circlesStartX + (numCircles - 1) * (circleRadius * 2 + 24); // GBS is always the last circle
          
          const helloTextY = circlesBottomY + 10; // 10pt below circles for "Hello"
          
          // Only show "Processed in X days" text if StatusId is 6
          if (invoiceData.statusId === 6) {
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(9);
            doc.setTextColor(brown[0], brown[1], brown[2]);          
            const processedDays = invoiceData.miApproval?.days || 0; // fallback to 0 if no data
            doc.text(`Processed in ${processedDays} days`, secondCircleCx, helloTextY, { align: 'center' });
            const GBSDays = invoiceData.gbsApproval?.days || 0; // fallback to 0 if no data           
            // GBS is always the last circle regardless of whether MI Second Level is present
            doc.text(`Processed in ${GBSDays} days`, gbsCircleCx, helloTextY, { align: 'center' });
          }
          
          // Center the Requestor: text under the first circle
          const requestorLabel = 'Requestor: ';
          doc.setFont('helvetica', 'bold');
          doc.setFontSize(10.4);
          doc.setTextColor(brown[0], brown[1], brown[2]);
          const requestorLabelWidth = doc.getTextWidth(requestorLabel);
          // Move text further below and start under the first circle (not centered)
          const requestorTextY = circlesBottomY + 30; // 12pt more below circles
          const requestorTextX = firstCircleCx - 32;

          // Draw requestor label
          doc.setFont('helvetica', 'bold');
          doc.setFontSize(10.4);
          doc.setTextColor(brown[0], brown[1], brown[2]);
          doc.text(requestorLabel, requestorTextX, requestorTextY, {align:'left'});

          // Place the request date directly after the label (no name)
          doc.setFont('helvetica', 'normal');
          doc.setFontSize(9.6);
          doc.setTextColor(80, 80, 80);
          const requestDateX = requestorTextX + requestorLabelWidth + 6; // Small gap after label
          doc.text(String(invoiceData.requestDate || ''), Number(requestDateX) || 10, Number(requestorTextY) || 10, {align:'left'});

          // Add MI Internal entry below Requestor with same styling and layout
          const miInternalY = requestorTextY + 20; // 20pt below requestor line
          const miInternalLabel = 'MI Internal: ';
          doc.setFont('helvetica', 'bold');
          doc.setFontSize(10.4);
          doc.setTextColor(brown[0], brown[1], brown[2]);
          const miInternalLabelWidth = doc.getTextWidth(miInternalLabel);
          doc.text(miInternalLabel, requestorTextX, miInternalY, {align:'left'});

          // MI Internal date directly after the label (no name)
          doc.setFont('helvetica', 'normal');
          doc.setFontSize(9.6);
          doc.setTextColor(80, 80, 80);
          const miInternalDateX = requestorTextX + miInternalLabelWidth + 6; // Small gap after label
          const miInternalDate = invoiceData.miApproverDate;
          // doc.text(miInternalDate, miInternalDateX, miInternalY, {align:'left'});
          doc.text(String(invoiceData.miApproverDate || ''), Number(miInternalDateX) || 10, Number(miInternalY) || 10, { align: 'left' });


          // Add GBS entry below MI Internal with same styling and layout
          const gbsY = miInternalY + 20; // 20pt below MI Internal line
          const gbsLabel = 'GBS: ';
          doc.setFont('helvetica', 'bold');
          doc.setFontSize(10.4);
          doc.setTextColor(brown[0], brown[1], brown[2]);
          const gbsLabelWidth = doc.getTextWidth(gbsLabel);
          doc.text(gbsLabel, requestorTextX, gbsY, {align:'left'});

          // GBS date directly after the label (no name)
          doc.setFont('helvetica', 'normal');
          doc.setFontSize(9.6);
          doc.setTextColor(80, 80, 80);
          const gbsDateX = requestorTextX + gbsLabelWidth + 6; // Small gap after label
          const gbsDate = invoiceData.gbsApproverDate;
          doc.text(String(invoiceData.gbsApproverDate || ''), Number(gbsDateX) || 10, Number(gbsY) || 10, { align: 'left' });

          // Add extra space at the bottom for visual comfort (updated to use gbsY)
          const afterSectionY = Math.max(approvalCommentsBottomY, gbsY + 40);
          doc.setDrawColor(brown[0], brown[1], brown[2]);
          doc.setLineWidth(1);
          doc.line(40, afterSectionY + 40, pageWidth - 40, afterSectionY + 40);
          // Clean up old blob URL if it exists
          if (this.blobUrl) {
            URL.revokeObjectURL(this.blobUrl);
          }
          
          // Show PDF in UI using blob URL
          const pdfBlob = doc.output('blob');
          this.blobUrl = URL.createObjectURL(pdfBlob);
          this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.blobUrl);
          this.spinnerService.hideSpinner();
          this.toastr.success('PDF Previewed Successfully', 'Success');
        }).catch(error => {
          this.spinnerService.hideSpinner();
          console.error('Error loading jspdf-autotable:', error);
          this.isLoading = false;
        });
      }).catch(error => {
        this.spinnerService.hideSpinner();
        console.error('Error loading jspdf:', error);
        this.isLoading = false;
      });
    } catch (error) {
      this.spinnerService.hideSpinner();
      this.toastr.error('Failed to fetch invoice data for PDF.', 'Error');
      this.isLoading = false;
    }
  }

onDownloadPDF() {
  if (!this.pdfSrc) {
    this.toastr.warning('No PDF available to download.', 'Warning');
    return;
  }

  const pdfBlob = this.pdfSrc as string;
  const link = document.createElement('a');
  link.href = pdfBlob;
  link.download = 'AdjustmentRequest_Sample.pdf';
  link.click();
}

// Add a method to clear error state on input
onAdjReqIdInput() {
  this.adjReqIdError = false;
  this.adjReqIdErrorMessage = '';
}

ngOnDestroy() {
  if (this.blobUrl) {
    URL.revokeObjectURL(this.blobUrl);
    this.blobUrl = null;
  }
}
}
